import {Box, Stack, Typography} from "@mui/material";
import type {ContentWordCount} from "../../../../../sdo/ContentWordCount.ts";
import type {ContentFramePointer} from "../../../../../sdo/ContentFramePointer.ts";
import ContentFrameCard from "../../../intel/panels/resources/ContentFrameCard.tsx";

interface ContentWordDetailProps {
    word: ContentWordCount;
    frames: ContentFramePointer[];
}

const caseLabels: { key: keyof ContentWordCount; label: string }[] = [
    {key: "acronym", label: "Acronym"},
    {key: "allLower", label: "All Lower"},
    {key: "allUpper", label: "All Upper"},
    {key: "camelCase", label: "Camel Case"},
    {key: "mixedCase", label: "Mixed Case"},
    {key: "titleCase", label: "Title Case"},
];

function ContentWordDetail({word, frames}: ContentWordDetailProps) {
    return (
        <Stack direction="column" spacing={2} sx={{height: "100%", minHeight: 0, overflowY: "auto"}}>
            {/* Case Variations */}
            <Box sx={{display: "flex", flexWrap: "wrap", gap: "4px 16px", padding: "4px 0", justifyContent: "center"}}>
                {caseLabels.map(({key, label}) => (
                    <Typography key={key} sx={{color: "#a8b8c0", fontSize: "0.75rem", fontWeight: 500, whiteSpace: "nowrap"}}>
                        {label}: <Box component="span" sx={{color: "#f2f5fa", fontWeight: 700}}>{word[key] as number}</Box>
                    </Typography>
                ))}
            </Box>

            {/* Content Frames */}
            <Box>
                <Typography sx={{
                    color: "#a8b8c0",
                    fontSize: "0.85rem",
                    fontWeight: 700,
                    letterSpacing: 0.3,
                    borderBottom: "1px solid #3F464F",
                    paddingBottom: "6px",
                    marginBottom: "10px",
                    textAlign: "left",
                }}>
                    Content Frames ({frames.length})
                </Typography>
                {frames.length > 0 ? (
                    <Stack direction="column" spacing={1}>
                        {frames.map((frame) => (
                            <ContentFrameCard key={frame.uid} frame={frame}/>
                        ))}
                    </Stack>
                ) : (
                    <Typography sx={{
                        color: "rgba(242, 245, 250, 0.4)",
                        fontSize: "0.80rem",
                        fontStyle: "italic",
                        textAlign: "center",
                        padding: "12px",
                    }}>
                        No content frames contain this word
                    </Typography>
                )}
            </Box>
        </Stack>
    );
}

export default ContentWordDetail;
